import { serviceUsers } from "../../../../Collaborator/service";
import { CreateProjectUsers, Roles, UserRole } from "../../../model";
import { service } from "../../../service/service";

function convertStringInNumber(array: any[]) {
  const collaborator = [] as UserRole[];
  array?.forEach((item: UserRole) => {
    const rolesId: number[] = [];
    item.rolesId?.forEach((number: any) => {
      rolesId.push(Number(number));
    });
    collaborator.push({
      userId: Number(item.userId),
      rolesId: rolesId,
      allocationTime: item.allocationTime,
      hourly_pay: item.hourly_pay,
      rate_hour: +String(item.rate_hour)?.replace(",", "."),
      end_date: item.end_date
    });
  });
  return collaborator;
}

async function getUsers(token: string) {
  return await serviceUsers.getUsers(token);
}

function getRoles(setValue: any, roles) {
  const newList = roles?.map((element: Roles, index: number) => {
    return {
      id: index,
      name: element?.name,
      checked: false,
      fieldId: element?.id,
    };
  });
  setValue(newList);
}

function postProjects({ formData, file = undefined }: any, token: string) {
  const body = JSON.stringify(formData);
  return service
    .postProjects({ body, file }, token)
    .then((data) => {
      return data;
    })
    .catch((err) => console.error(err));
}

function putProjects({ formData, file = undefined }: any, params: string, token: string) {
  const body = JSON.stringify(formData);
  return service
    .putProjects({ body, file }, params, token)
    .then((data) => {
      return data;
    })
    .catch((err) => console.error(err));
}

function objectGenerator(element: Roles) {
  const obj = {
    id: element.id,
    name: element.name,
    checked: !element.checked,
  };
  return obj;
}

function compareArrayAndInclude(arrayOne: any[], arrayTwo: any[]) {
  const newArray = arrayOne?.map((element: any) => {
    if (!arrayTwo.includes(element.name)) return element;
    const data = objectGenerator(element);
    return data;
  });
  return newArray;
}

async function delayTime(data: any, time: number) {
  return await setTimeout(() => {
    return data;
  }, time);
}

function returnIdProjectManager(roles: Roles[]) {
  const item = roles?.filter((item) => {
    if (item?.name === "GERENTE DE PROJETOS") return true;
  });
  return item && item[0]?.fieldId;
}

export {
  convertStringInNumber,
  returnIdProjectManager,
  delayTime,
  compareArrayAndInclude,
  postProjects,
  putProjects,
  getUsers,
  getRoles,
  objectGenerator,
};
